/** Quick Docs
 * Warranty and Return data have the same JSON format (see: page.warranty.liquid)
 * It categorizes into regions [1st level] and each region has "dates", "locales" and "format" key [2nd level] 
 * 
 * FORMAT: We can ignore this one as it is there just to support old format.
 * DATE: If ever there is a new doc (warranty and return) make sure the date should be added first on the array list 
 * ---example: 'date' : [<insert_new_date_here>, 2022-04-20]
 * LOCALES: If the new doc supports multi-language then it should be added like this. 
 * Dates then the array of locales
 * ---example: 'locales': { '2021-12-20': ['en', 'it', 'de' ...] }
 * 
 * LATEST URL SAMPLE:
 * Warranty Statement Filename Format: https://assets.secretlab.co/docs/YYYY-MM-DD/warranty/warranty-statement_XX-XX.pdf
 * Return Policy Filename Format: https://assets.secretlab.co/docs/YYYY-MM-DD/refund_and_return/rnrp_XX-XX.pdf
 */

/**
 * Initialise common variable
 * @param {*} type 
 * @returns 
 */
function warrantyInit (type) {
    let inputWarrantyDate = document.getElementById('input-warranty-date')
    let selectLocale = document.getElementById('select-locales')
    let pdfLink = document.getElementById('pdf-link')
    let warrantyAlert =  document.getElementsByClassName('warranty-notif')[0]

    if(type === 'return') {
        inputWarrantyDate = document.getElementById('input-return-date')
        selectLocale = document.getElementById('select-locales-return')
        pdfLink = document.getElementById('pdf-link-return')
        warrantyAlert =  document.getElementsByClassName('return-notif')[0]
    }
    
    return {
        inputWarrantyDate,
        selectLocale,
        pdfLink,
        warrantyAlert
    }
}

/**
 * 
 * @param {*} currStore 
 * @param {*} dataDates 
 * @param {*} localization 
 * @param {*} type 
 */
function searchPDFurl(currStore, dataDates, localization, type) {
    const { inputWarrantyDate, selectLocale, pdfLink, warrantyAlert} = warrantyInit(type)
    let resultDate = null
    let resultLocale = null

    initializeDate('.warranty-date',{"locale": localization.localeStore} /*{ dateFormat: "d/m/Y" }*/)
    initializeDate('.return-date',{"locale": localization.localeStore}/*{ dateFormat: "d/m/Y" }*/)

    inputWarrantyDate.addEventListener('change', onChangeDate)
    selectLocale?.addEventListener('change', onChangeLocale)
    pdfLink.addEventListener('click', openWarrantyPDF)
   
    function openWarrantyPDF(event) {
        window.open(event.target.getAttribute('data-url'), "_blank")
    }

    function onChangeLocale(event) {
        event.preventDefault()
        if(resultDate)
            onChangeFunc()
    }

    function onChangeDate(event) {
        event.preventDefault()
        onChangeFunc()
    }

    function onChangeFunc() {
        const withDates = dataDates[currStore]['dates']
        const withLocales = dataDates[currStore]['locales']
        const withFormat = dataDates[currStore]['format']
        let hasFormatDate = null
        let hasLocales = null
        let hasLang = false
        
        if(warrantyAlert)
            warrantyAlert.innerHTML = ''

        resultDate = filterDates(inputWarrantyDate.value, withDates)
        resultLocale = selectLocale != undefined ? selectLocale.value : 'en'
        
        if(withLocales != undefined && withLocales[resultDate] ) {
            hasLocales = withLocales[resultDate]
            hasLang = true

            // set condition if locales not found
            if(!hasLocales.includes(resultLocale)) {
                if(resultLocale != 'en') 
                    warrantyAlert.innerHTML = localization.unavailable_notification

                if(!hasLocales.includes('en')) 
                    resultDate = recursiveDateCheck(resultDate, withDates, withLocales)
                
                resultLocale = 'en'
            }
        }

        if(resultLocale != 'en' && !hasLang) {
            warrantyAlert.innerHTML = localization.unavailable_notification
            resultLocale = 'en'
        }

        if(withFormat != undefined && withFormat[resultDate])
            hasFormatDate = withFormat[resultDate] 

        setURL({ 
            pdfLink, 
            resultDate, 
            resultLocale, 
            currStore, 
            hasFormatDate, 
            hasLocales 
        }, type)
    }
}

/**
 * 
 * @param {*} data 
 * @param {*} type 
 * @returns 
 */
function setURL(data = {}, type) {
    const url = {
        warranty: staticURL(data.resultDate).warranty,
        return: staticURL(data.resultDate).return
    }

    const ext = 'pdf'
    const multiLangRegion = ['EU', 'KR', 'XX']

    if(data?.hasFormatDate) {
        data.pdfLink.setAttribute('data-url', `${url[type]}${data.hasFormatDate}.${ext}`) 
        data.pdfLink.removeAttribute('disabled')
        return 
    }

    if(data?.hasLocales || multiLangRegion.includes(currStore)) {
        data.pdfLink.setAttribute('data-url', `${url[type]}${data.currStore}-${data.resultLocale}.${ext}`) 
        data.pdfLink.removeAttribute('disabled')
        return
    }
    
    if(data?.resultLocale === 'en') {
        data.pdfLink.setAttribute('data-url', `${url[type]}${data.currStore}.${ext}`) 
        data.pdfLink.removeAttribute('disabled')
    }
}

/**
 * 
 * @param {*} date 
 * @returns 
 */
function staticURL(date) {
    return {
        warranty: `https://assets.secretlab.co/docs/${date}/warranty/warranty-statement_`,
        return: `https://assets.secretlab.co/docs/${date}/refund_and_return/rnrp_`
    }
}

/**
 * 
 * @param {*} selected 
 * @param {*} dates 
 * @returns 
 */
function filterDates(selected, dates) {
    const newSelected = setTimeZone(selected, 'Asia/Singapore')
    const newDates = dates.map(date => setTimeZone(date, 'Asia/Singapore'))
    let result = setTimeZone(new Date(), 'Asia/Singapore')
    
    // if current date is less than the last value of an array, return the latter 
    if(newSelected.getTime() < newDates[newDates.length-1].getTime())
        return formatDate(newDates[newDates.length-1])

    result = newDates.reduce((acc, curr) => {
        if(newSelected.getTime() >= curr.getTime()) {
            acc = [...acc, curr]
        }
        return acc
    }, [])

    return formatDate(result[0])
}

/**
 * 
 * @param {*} currStore 
 * @param {*} warrantyDates 
 * @param {*} returnDates 
 * @param {*} localization 
 */
function modalPDF(currStore, warrantyDates, returnDates, localization) {
    document.querySelectorAll('.viewLatestDoc').forEach(i => i.addEventListener('click', function(e) {
        e.preventDefault()
        const multiLangRegion = ['EU', 'KR', 'XX', 'CA']
        const type = e.target.getAttribute('data-type')
        const textPolicy = document.getElementById('text-policy')
        const anchor = document.getElementById('pdf-link-btn-modal')
        const select = document.getElementById('select-locales-modal')

        let url = null
        
        if(textPolicy)
            textPolicy.innerHTML = type === 'warranty' ? localization.view_warranty_statement : localization.view_return_policy

        if(!multiLangRegion.includes(currStore)) {
            if(type === 'warranty')
                url = `${staticURL(warrantyDates[currStore]['dates'][0]).warranty}${currStore}.pdf`

            if(type === 'return')
                url = `${staticURL(returnDates[currStore]['dates'][0]).return}${currStore}.pdf`

            window.open(url, "_blank")
            return
        }

        // set value to anchor tag directly
        runLogic(type, anchor, select)

        // show modal
        const customModal = new bootstrap.Modal(document.getElementById('modalViewPDF'), {})
        customModal.show()

        select.addEventListener('click', function(e) {
            e.preventDefault()
            runLogic(type, anchor, select)
        })
    }))

    function runLogic(type, anchor, select) {
        const withLocales = type === 'warranty' ? warrantyDates[currStore]['locales'] : returnDates[currStore]['locales']
        const withDates = type === 'warranty' ? warrantyDates[currStore]['dates'] : returnDates[currStore]['dates']
        const warrantyAlert = document.getElementsByClassName('modal-notif')[0]
        let resultDate = type === 'warranty' ? warrantyDates[currStore]['dates'][0] : returnDates[currStore]['dates'][0]
        let hasLang = false
        let resultLocale = select.value

        if(warrantyAlert)
            warrantyAlert.innerHTML = ''

        // same logic in searchRun function
        // heavy logic here
        if(withLocales != undefined && withLocales[resultDate] ) {
            hasLocales = withLocales[resultDate]
            hasLang = true
            
            // set condition if locales not found
            if(!hasLocales.includes(resultLocale)) {
                if(resultLocale != 'en') 
                    warrantyAlert.innerHTML = localization.unavailable_notification

                if(!hasLocales.includes('en')) 
                    resultDate = recursiveDateCheck(resultDate, withDates, withLocales)
                
                resultLocale = 'en'
            }
        }

        if(resultLocale != 'en' && !hasLang) {
            warrantyAlert.innerHTML = localization.unavailable_notification
            resultLocale = 'en'
        }

        anchor.setAttribute('href', `${staticURL(resultDate)[type]}${currStore}-${resultLocale}.pdf`)
    }
}

/**
 * 
 * @param {*} resultDate 
 * @param {*} withDates 
 * @param {*} withLocales 
 * @returns 
 */
function recursiveDateCheck(resultDate, withDates, withLocales) {
    const resultIndex = withDates.indexOf(resultDate)
    const newResultDate = withDates[resultIndex + 1]

    if(newResultDate != undefined) {  
        if(withLocales[newResultDate] == undefined || withLocales[newResultDate].includes('en')) {
            return newResultDate
        } else {
            recursiveDateCheck(newResultDate, withDates, withLocales)
        }
    }

    return
}

/**
 * 
 * @param {*} date 
 * @returns 
 */
function formatDate(date) {
    var year = date.getFullYear().toString()
    var month = (date.getMonth() + 101).toString().substring(1)
    var day = (date.getDate() + 100).toString().substring(1)
    return year + "-" + month + "-" + day

}

/**
 * 
 * @param {*} date 
 * @param {*} timeZone 
 * @returns 
 */
function setTimeZone(date, timeZone) {
    if (typeof date === 'string') {
        return new Date(
            new Date(date).toLocaleString('en-US', { timeZone })
        );
    }
}

/**
 * 
 * @param {*} val 
 * @param {*} config 
 */
function initializeDate(val, config = {}) {
    const defaultConfig = {
        ...config,
        prevArrow: '',
        nextArrow: '',
        disableMobile: true
    } 
    
    flatpickr(document.querySelector(val), defaultConfig)
}

/**
 * Initialise
 */
searchPDFurl(currStore, warrantyDates, localization, 'warranty')
searchPDFurl(currStore, returnDates, localization, 'return')
modalPDF(currStore, warrantyDates, returnDates, localization)

/**
 * Note: This function is not being used anywhere, but keeping it for future use.
 * Populate data dynamically in select tag
 * @param {*} select 
 * @returns 
 */
function populateSelectTag(select = {}) {
    const locales = { 'en': 'English', 'ko': 'Korea', 'de': '', 'it': '', 'es': '', 'fr': '', 'da': '', 'nl': '', 'pl': '', 'sv': '' }
    select.element.length = 0

    if(select.result) {
        for(const item of select.result) {
            select.element.add(new Option(locales[item], item))
        }
        return
    }

    select.element.add(new Option(select.data['en'], 'en'))
}